import React from "react";

class ProjectPageComponent extends React.Component
{
    scrollTop() {
        const Scroll = require('react-scroll');
        const scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    render() {
        return (
            <>
            </>
        );
    }
}

export default ProjectPageComponent;